import { areCommentsVisible } from './comment';
import { isInHandoffMode } from './handoff';
import { isHovering } from './hover';
export function areTimersEnabled(state) {
    return (!isInHandoffMode(state) && !areCommentsVisible(state) && !isHovering(state));
}
